import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-image-w',
  template: `
    <p>
      image-w works!
    </p>
  `,
  styles: []
})
export class ImageWComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
